// extracted by mini-css-extract-plugin
export var disabled = "_2y-3";
export var growableInput = "_2y-0";
export var tagContainer = "_2y-2";
export var textInput = "_2y-1";